const Navlinks = () => {
  const links = [
    { address: "/#home", title: "Home" },
    { address: "/#about", title: "About Us" },
    { address: "/#benefits", title: "Services" },
    { address: "/#curriculum", title: "Curriculum" },
    // { address: "/", title: "Pricing" },
  ];

  return (
    <div>
      <ul className="flex items-center">
        {links.map((link, i) => {
          return (
            <li key={i} className="ml-10 font-semibold text-normal sys_black">
              <a href={link.address}>{link.title}</a>
            </li>
          );
        })}
        <li className="ml-10 px-6 py-2 font-semibold text-white rounded sys_bg_primary"><a href="#apply">Get Started</a></li>
      </ul>
    </div>
  );
};


export default Navlinks